import { render, staticRenderFns } from "./BAutocompleteCommon.vue?vue&type=template&id=44f7563e&"
import script from "./BAutocompleteCommon.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports